import React from 'react'


import ReportAndEditShipments from './common/ReportAndEditShipments'


export default props => (
  <ReportAndEditShipments
    formType="buybacks"
    isEditForm={false}
    {...props}
  />
)
